import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AnimationFactory from "../../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import { getURLParameter } from "../../../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractMediator from "../../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../../core/ui/SkinKeyRegistry";
import TutorialEvent from "../../events/TutorialEvent";

export default class TutorialScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {LanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
        this._tutorialHubMediator = this._mediatorManager.createMediator(this._target, SkinKeyRegistry.TUTORIAL_HUB_SKIN);
        if (ranj.DEBUG && getURLParameter('skiptutorial') == 1) {
            setTimeout(() => { this.dispatch(TutorialEvent.CLOSE_REQUEST); });
        }
    }

    initializeButton(buttonId, lpId = "tutorial.general.ContinueButton") {
        this._continueButton = this.createButton(this._target[buttonId], this._handleContinueButton.bind(this), this._languagePack.getText(lpId));
        this._continueButton.target.alpha = 0;
        createjs.Tween.get(this._continueButton.target)
            .wait(500)
            .to({ alpha: 1 }, 500, createjs.Ease.sineOut);
    }

    _handleContinueButton() {
        console.log(`pressed tutorial continue: ${this._continueButton.target.name}`, this._continueButton)

        this._continueButton.setEnabled(false);

        this._tutorialHubMediator.destroy();

        this.closeScreen(this._target, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 650, createjs.Ease.sineInOut)
        });
    }
}